<template>
  <div class="block-wrap">
    <BlockTitle title-type="policy">
      <div @click="toList">更多政策》</div>
    </BlockTitle>
    <div class="content-wrap">
      <div class="big-img-wrap">
        <img :src="listBig.coverImg || 'http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/policy-bg.jpg'" alt="">
        <div class="big-news">
          <h3 class="card-title">{{listBig.title}}</h3>
          <div class="card-time">{{listBig._releaseDate}}</div>
          <div class="card-desc">{{listBig.briefIntroduction || '-'}}</div>
          <div class="card-more" @click="toDetail(listBig)">查看详情</div>
        </div>
      </div>
      <div class="card-list-wrap">
        <div class="card-item" v-for="(item, index) in list" v-show="index !== 0" :key="index">
          <h3 class="card-title">{{item.title}}</h3>
          <div class="card-time">{{item._releaseDate}}</div>
          <div class="card-desc">{{item.briefIntroduction || '-'}}</div>
          <div class="card-more" @click="toDetail(item)">查看详情</div>
        </div>
      </div>
    </div>
    <SplitLine />
  </div>
</template>

<script>
import BlockTitle from "@/components/BlockTitle";
import tempImg from '@/assets/images/policy-bg.png';
import router from '@/router';

export default {
  data() {
    return {
      tempImg
    }
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    listBig() {
      if (this.list.length >= 1) {
        return this.list[0]
      }
      return {}
    }
  },
  components: {
    BlockTitle,
  },
  methods: {
    toList() {
      router.push('/policy');
    },
    toDetail(item) {
      router.push(`/policy/detail?aId=${item.id}`);
    },
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';

.block-wrap {
  padding-top: 36px;
}
.content-wrap {
  margin-top: 20px;
  margin-bottom: 57px;

  .big-img-wrap {
    width: 100%;
    position: relative;
    margin-bottom: 32px;

    > img {
      display: block;
      width: 100%;
    }

    .big-news {
      width: 50%;
      padding: 40px;
      background: #FDFFFD;
      backdrop-filter: blur(0px);
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;

      &:hover {
        .card-more {
          color: #06AE63;
        }
      }

      .card-title {
        &:extend(.line2);
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #131415;
        line-height: 28px;
        margin-bottom: 9px;
      }

      .card-time {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9D9E9E;
        line-height: 20px;
        margin-bottom: 10px;
      }

      .card-desc {
        &:extend(.line4);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        line-height: 21px;
        margin-bottom: 43px;
      }

      .card-more {
        width: 120px;
        height: 40px;
        background: #F1F3F3;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        line-height: 40px;
        text-align: center;
      }
    }
  }

  .card-list-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .card-item {
      width: 374px;
      height: 270px;
      background: #FDFFFD;
      border: 1px solid #E1E1E1;
      padding: 28px 32px;
      cursor: pointer;

      &:hover {
        background: #06AE63;
        border: none;

        .card-title, .card-time, .card-desc {
          color: #FDFFFD;
        }

        .card-more {
          background: #FDFFFD;
          color: #06AE63;
        }
      }

      .card-title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #131415;
        line-height: 25px;
        margin-bottom: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .card-time {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9D9E9E;
        line-height: 20px;
        margin-bottom: 9px;
      }

      .card-desc {
        &:extend(.line3);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        line-height: 21px;
        margin-bottom: 48px;
      }

      .card-more {
        width: 120px;
        height: 40px;
        line-height: 40px;
        background: #F1F3F3;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        text-align: center;
        margin-left: auto;
      }
    }
  }
}
</style>